// Authenticated Encryption with Associated Data. Used for encrypting session
// traffic after key agreement. The AEAD construction binds ciphertext integrity
// to optional associated data (e.g. message headers), preventing tampering.
import { chacha20poly1305 as nobleChacha } from '@noble/ciphers/chacha.js';
export const chacha20Poly1305 = {
    name: 'chacha20-poly1305',
    keySize: 32,
    nonceSize: 12,
    tagSize: 16,
    encrypt(plaintext, key, nonce, aad) {
        const cipher = nobleChacha(key, nonce, aad);
        return cipher.encrypt(plaintext);
    },
    decrypt(ciphertext, key, nonce, aad) {
        const cipher = nobleChacha(key, nonce, aad);
        return cipher.decrypt(ciphertext);
    }
};
